import { useCallback, useState } from "react";

const useToggle = (init = false): [boolean, () => void] => {
	const [value, setValue] = useState(init);
	const toggle = useCallback(() => setValue((p) => !p), []);
	return [value, toggle] as const;
};

export default useToggle;
